import React from 'react';
import { Music, Music2, Zap, Shield, Check, Lock, Download } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function PricingSection() {
  return <section id="pricing" className="gradient-section w-full py-12 md:py-20 px-4" data-id="element-227">
      <div className="max-w-3xl mx-auto" data-id="element-228">
        {/* Decorative notes */}
        <div className="flex justify-center gap-4 mb-4 opacity-60" aria-hidden="true" data-id="element-229">
          <Music className="w-8 h-8 text-yellow-300" data-id="element-230" />
          <Music2 className="w-8 h-8 text-white" data-id="element-231" />
          <Music className="w-8 h-8 text-orange-300" data-id="element-232" />
        </div>

        {/* Title */}
        <div className="text-center mb-8 md:mb-10" data-id="element-233">
          <h2 className="font-nunito font-black text-white text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-234">
            PRECIO
            <span className="text-yellow-300" data-id="element-235"> ESPECIAL</span>
          </h2>
          <p className="text-purple-200 font-semibold mt-2 text-base md:text-lg" data-id="element-236">
            Oferta por tiempo limitado
          </p>
        </div>

        {/* Pricing card */}
        <div className="bg-white rounded-3xl p-6 md:p-12 shadow-2xl text-center mb-6 md:mb-8" data-id="element-237">
          {/* Guarantee badge */}
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 font-nunito font-bold px-3 md:px-4 py-2 rounded-full text-xs md:text-sm mb-5 md:mb-6" data-id="element-238">
            <Shield className="w-4 h-4" data-id="element-239" /> Garantía 30 días sin riesgo
          </div>

          {/* Price */}
          <div className="mb-5 md:mb-6" data-id="element-240">
            <p className="text-gray-400 font-semibold text-base md:text-lg line-through mb-1" data-id="element-241">
              Precio Normal: $57 USD
            </p>
            <p className="text-gray-500 text-xs md:text-sm mb-3 md:mb-4" data-id="element-242">
              (Valor real: $95+ si compraras plantillas + recursos por separado)
            </p>
            <div className="flex items-center justify-center gap-2 md:gap-4" data-id="element-243">
              <span className="font-nunito font-black text-gray-300 text-2xl md:text-3xl line-through" data-id="element-244">
                $57
              </span>
              <span className="font-nunito font-black text-orange-500 text-6xl sm:text-7xl md:text-8xl" data-id="element-245">
                $17
              </span>
              <span className="font-nunito font-black text-gray-600 text-xl md:text-2xl" data-id="element-246">
                USD
              </span>
            </div>
            <div className="inline-flex items-center gap-1 bg-red-100 text-red-600 font-nunito font-black px-3 md:px-4 py-1 rounded-full text-base md:text-lg mt-2" data-id="element-247">
              <Check className="w-4 h-4" strokeWidth={3} data-id="element-248" /> Ahorras $40 (70%
              descuento)
            </div>
          </div>

          {/* What's included */}
          <div className="bg-gray-50 rounded-2xl p-4 md:p-6 mb-6 md:mb-8 text-left" data-id="element-249">
            <h3 className="font-nunito font-black text-gray-900 text-base md:text-lg mb-3 md:mb-4 text-center flex items-center justify-center gap-2" data-id="element-250">
              <Check className="w-5 h-5 text-green-500" strokeWidth={3} data-id="element-251" />{' '}
              Incluye TODO:
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-3" data-id="element-252">
              {['40 Planes Semanales', '10 Plantillas Imprimibles', '2 Certificados para Alumnos', 'Calendario Anual Visual', '50 Recursos Rápidos', 'Rúbricas de Evaluación', 'Guía Conducta en Clase', 'Check List Evaluación'].map(item => <div key={item} className="flex items-center gap-2 text-gray-700 font-semibold text-sm md:text-base" data-id="element-253">
                  <Check className="w-4 h-4 text-green-500 flex-shrink-0" strokeWidth={3} data-id="element-254" />
                  {item}
                </div>)}
            </div>
          </div>

          {/* CTA Button */}
          <a href="https://www.megateacherpack.com/cart/48020325990648:1" target="_blank" rel="noopener noreferrer" className="btn-pulse inline-flex items-center justify-center gap-3 w-full bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-400 hover:to-red-400 text-white font-nunito font-black text-lg md:text-2xl px-6 md:px-8 py-5 md:py-6 rounded-2xl shadow-2xl cursor-pointer transition-colors" aria-label="Comprar 36 Semanas de Música por $17 USD" data-id="element-255">
            <Zap className="w-6 h-6 flex-shrink-0" data-id="element-256" />
            <span data-id="element-257">
              SÍ, QUIERO MIS 40 SEMANAS LISTAS
              <span className="block text-sm md:text-base font-bold mt-1 text-orange-100" data-id="element-258">
                Comprar Ahora $17 USD — Acceso Inmediato
              </span>
            </span>
          </a>

          {/* Trust signals */}
          <div className="flex flex-wrap justify-center gap-3 md:gap-4 mt-5 md:mt-6 text-gray-500 text-xs md:text-sm font-semibold" data-id="element-259">
            <span className="flex items-center gap-1" data-id="element-260">
              <Lock className="w-3.5 h-3.5" data-id="element-261" /> Pago Seguro via Hotmart/Stripe
            </span>
            <span className="flex items-center gap-1" data-id="element-262">
              <Download className="w-3.5 h-3.5" data-id="element-263" /> Descarga en 1 minuto
            </span>
            <span className="flex items-center gap-1" data-id="element-264">
              <Shield className="w-3.5 h-3.5" data-id="element-265" /> Garantía 30 días
            </span>
          </div>
        </div>

        {/* Countdown */}
        <div className="flex justify-center" data-id="element-266">
          <CountdownTimer data-id="element-267" />
        </div>

        {/* Guarantee section */}
        <div className="mt-8 md:mt-10 bg-white/10 backdrop-blur-sm rounded-2xl p-6 md:p-8 border border-white/20 text-center" data-id="element-268">
          <Shield className="w-12 h-12 text-green-400 mx-auto mb-3 md:mb-4" data-id="element-269" />
          <h3 className="font-nunito font-black text-white text-xl md:text-3xl mb-2 md:mb-3" data-id="element-270">
            GARANTÍA 100% — 30 DÍAS SIN RIESGO
          </h3>
          <p className="text-purple-200 font-semibold text-base md:text-lg mb-3 md:mb-4" data-id="element-271">
            Si en 7 días NO notas diferencia en tus clases:
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2 md:gap-3" data-id="element-272">
            {['Devolvemos 100% tu dinero', 'SIN preguntas', 'SIN explicaciones', 'SIN molestias'].map(item => <div key={item} className="bg-white/10 rounded-xl p-3 text-white font-semibold text-sm" data-id="element-273">
                → {item}
              </div>)}
          </div>
          <p className="text-yellow-300 font-nunito font-black text-base md:text-lg mt-4 md:mt-5" data-id="element-274">
            ¿Por qué tan seguro? Porque FUNCIONA. Más de 1,200 maestros lo usan
            ya en 2026.
          </p>
        </div>
      </div>
    </section>;
}